import React from 'react';
import './style.css';
import workers from "../../assests/Home/workers.jpeg"
import cons from "../../assests/Home/cons.jpg"
import manager from "../../assests/Home/manager.jpeg"

const About = () => {
    return (
        <div className="about-section">
            <div className="about-text">
                <p className="subtitle">🔺Your reliable partner in construction and building solutions.</p>
                <h1>Trusted  Construction Partner</h1>
                <p className="description">
                    Our team is made up of dedicated engineers, supervisors, and field workers committed to quality, safety, and timely delivery. We combine practical knowledge with advanced tools to meet the toughest project demands — no matter the size.
                </p>
                <ul className="services-list">
                    <li>Comprehensive Construction Services</li>
                    <li>Precision Demolition & Cutting Services</li>
                    <li>Air Conditioning Solutions</li>
                    <li>Electrical Installation & Maintenance</li>
                    <li>Advanced Security & Surveillance Systems</li>
                </ul>

                
            </div>

            <div className="about-images">
                <div className="image-box">
                    <img src={workers} alt="Engineer" />
                    <p className="img-label">Best Workers</p>
                </div>
                <div className="image-box large">
                    <img src={cons} alt="Digital Crane" />
                    <p className="img-label">Construction Tools and Equipment</p>
                    <div className="success-box">
                        <strong>100%</strong>
                        <span>Success Rate</span>
                    </div>
                </div>
                <div className="image-box">
                    <img src={manager} alt="Best Workers" />
                    <p className="img-label">Project Manager</p>
                </div>
            </div>
        </div>
    );
};

export default About;
